/**
 * Design Tokens - Spacing
 * Exported from Figma: Enersee Platform 2.0 - _Foundation_DesignSystem
 *
 * Spacing values for consistent layout and component spacing.
 */

export const spacingTokens = {
  xxs: '2px', // spacing-xxs
  xs: '4px', // spacing-xs
  sm: '6px', // spacing-sm
  md: '8px', // spacing-md
  lg: '12px', // spacing-lg
  xl: '16px', // spacing-xl
  '2xl': '20px', // spacing-2xl
  '4xl': '32px', // spacing-4xl
  '6xl': '48px', // spacing-6xl
  '7xl': '64px', // spacing-7xl
  '8xl': '80px', // spacing-8xl
  '10xl': '128px', // spacing-10xl
} as const;

export type SpacingTokens = typeof spacingTokens;
